import { SwiperProps } from 'swiper/react';

import { CarouselType } from 'api/contentful/contentTypes.cloverdotcom';
import { browserBreakpoints } from 'utils/breakpoints';
import { EffectCreative } from 'swiper/modules';

export const BASE_SLIDER_SETTINGS: Readonly<SwiperProps> = {
  speed: 500,
  loop: false,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  watchSlidesProgress: true,
};

/**
 * Set Swiper paramerters
 * https://swiperjs.com/swiper-api#parameters
 */
export function computeSliderProps(type?: CarouselType): Readonly<SwiperProps> {
  const tablet = browserBreakpoints.mobile + 1;
  const desktop = browserBreakpoints.tablet + 1;

  switch (type) {
    case CarouselType.FEATURE:
      return {
        ...BASE_SLIDER_SETTINGS,
        spaceBetween: 25,
      };

    case CarouselType.PRODUCT:
      return {
        ...BASE_SLIDER_SETTINGS,
        spaceBetween: 25,
        breakpoints: {
          [browserBreakpoints.desktop]: {
            spaceBetween: 40,
          },
        },
      };

    case CarouselType.SQUARE:
    case CarouselType.ACCORDION:
    case CarouselType.ACCORDION_CASE_STUDY:
      return {
        ...BASE_SLIDER_SETTINGS,
        autoHeight: true,
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        breakpoints: {
          [tablet]: {
            slidesOffsetBefore: 24,
            slidesOffsetAfter: 24,
            spaceBetween: 24,
          },
          [desktop]: {
            slidesOffsetBefore: 48,
            slidesOffsetAfter: 48,
            spaceBetween: 24,
          },
        },
      };

    case CarouselType.HERO:
      return {
        ...BASE_SLIDER_SETTINGS,
        loop: true,
        slidesPerView: 1,
      };

    case CarouselType.DEVICE:
      return {
        ...BASE_SLIDER_SETTINGS,
        centeredSlides: true,
        loop: false,
        slidesPerView: 1,
        effect: 'creative',
        speed: 600,
        creativeEffect: {
          prev: {
            translate: ['-100%', 0, 0],
            scale: 0.75,
            opacity: 0,
          },
          next: {
            translate: ['100%', 0, 0],
            scale: 0.75,
            opacity: 0,
          },
        },
        modules: [EffectCreative],
      };

    default:
      return { ...BASE_SLIDER_SETTINGS };
  }
}
